import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/PDFPositionTool.css";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import PDFPositionTool from "../components/PDFPositionTool";

// Définir les types pour les options PDF
type PdfType = 'MonDevis.pdf' | 'DevisFoodinnov.pdf' | 'hillerbrandfdaregistration.pdf' | 'F_hillebrandfdaregistration.pdf' | 'REC_hillebrandfdaregistration.pdf';

interface PdfOption {
  url: string;
  fields: any; // Utiliser un type plus précis si possible
  firestoreDoc: string;
}

type PdfOptions = {
  [key in PdfType]: PdfOption;
};

const FdaPdfToolPage: React.FC = () => {
  const navigate = useNavigate();

  // Initialiser selectedOption en fonction de l'URL actuelle pour la navigation future
  const initialSelectedOption = () => {
    if (window.location.pathname === '/outil-fda-pdf') {
      return 'hillerbrandfdaregistration.pdf';
    } else if (window.location.pathname === '/admin/pdf-tool') {
      return 'MonDevis.pdf';
    } else if (window.location.pathname === '/devis-foodinnov-tool') {
      return 'DevisFoodinnov.pdf';
    } else {
      return ''; // Ou un autre défaut approprié
    }
  };

  const [selectedOption, setSelectedOption] = useState<PdfType | ''>(
    initialSelectedOption()
  );

  // Définir les options PDF ici avec les noms de fichiers comme clés
  const pdfOptions: PdfOptions = {
    'MonDevis.pdf': {
      url: '/pdfs/MonDevis.pdf',
      fields: {}, // Remplacez par les champs réels
      firestoreDoc: 'devisPositions'
    },
    'DevisFoodinnov.pdf': {
      url: '/pdfs/DevisFoodinnov.pdf',
      fields: {}, // Remplacez par les champs réels
      firestoreDoc: 'devisFoodinnovPositions'
    },
    'hillerbrandfdaregistration.pdf': {
      url: '/pdfs/hillebrandfdaregistration.pdf',
      fields: {}, // Remplacez par les champs réels
      firestoreDoc: 'fdaPositions'
    },
    'F_hillebrandfdaregistration.pdf': {
      url: '/pdfs/F_hillebrandfdaregistration.pdf',
      fields: {}, // Remplacez par les champs réels
      firestoreDoc: 'fdaPositionsFoodinnov'
    },
    'REC_hillebrandfdaregistration.pdf': {
      url: '/pdfs/REC_hillebrandfdaregistration.pdf',
      fields: {}, // Remplacez par les champs réels
      firestoreDoc: 'fdaPositionsREC'
    }
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as PdfType | '';
    setSelectedOption(value);

    // Rediriger en fonction de la sélection
    switch(value) {
      case 'hillerbrandfdaregistration.pdf':
      case 'F_hillebrandfdaregistration.pdf':
      case 'REC_hillebrandfdaregistration.pdf':
        navigate('/outil-fda-pdf');
        break;
      case 'MonDevis.pdf':
        navigate('/admin/pdf-tool');
        break;
      case 'DevisFoodinnov.pdf':
        // TODO: Ajouter la redirection vers la page de devis Foodinnov quand elle sera créée
        console.log('Redirection vers devis Foodinnov à implémenter');
        break;
      default:
        // Gérer le cas où l'option vide est sélectionnée (ne rien faire ou rediriger vers une page d'accueil de l'outil)
        break;
    }
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <div className="devis-container">
      <Header
        isAuthenticated={true}
        onLoginClick={() => navigate('/login')}
        onHomeClick={() => navigate('/')}
        onLogoutClick={handleLogout}
      />

      <div style={{
        display: "flex",
        gap: "40px",
        alignItems: "flex-start",
        flexWrap: "wrap",
        padding: "20px",
        maxWidth: "1400px",
        margin: "0 auto"
      }}>
        <div style={{
          flex: 2,
          minWidth: "800px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "20px"
        }}>
          {selectedOption && pdfOptions[selectedOption] && (
            <PDFPositionTool
              pdfOptions={pdfOptions}
              defaultPdfName={selectedOption}
            />
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FdaPdfToolPage;